import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

export const FrontpageLayout = ({ children }: PropsWithChildren) => (
  <Box
    className="frontpage"
    sx={{
      maxWidth: 1120,
      mx: "auto",
      pt: "clamp(16px, 3vw, 40px)",
      px: "clamp(16px, 4vw, 48px)",
      pb: 9,
      color: "text.primary",
    }}
  >
    {children}
  </Box>
);
